// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_c8-b";
export var colorBlue = "_c8-8";
export var colorDot = "_c8-0";
export var colorDotLarge = "_c8-2";
export var colorDotSmall = "_c8-1";
export var colorGreen = "_c8-7";
export var colorGrey = "_c8-3";
export var colorOrange = "_c8-5";
export var colorPink = "_c8-a";
export var colorPurple = "_c8-9";
export var colorRed = "_c8-4";
export var colorYellow = "_c8-6";